import Axios from 'axios'
import * as constants from '../helpers/Constants.js'
import Models from '@/store/ORM/models.js';

var menu = Axios.create({
  baseURL:constants.APIURL,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
})


menu.interceptors.response.use((response) =>{
  return response
},  (error) =>{
  if (error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('loggedin');
      localStorage.removeItem('vuex');

      
      Models.Reference.deleteAll();
      Models.Supplier.deleteAll();
      Models.Specialist.deleteAll();
      Models.CreatedMenu.deleteAll();
      Models.Specialist.deleteAll();
      Models.Nutritionist.deleteAll();
      Models.Client.deleteAll();
      Models.Event.deleteAll();
      Models.Product.deleteAll();

      let urls = window.location.href.split('#');
      window.open(urls[0],'_self');
  }
  return Promise.reject(error)
})



const getFoodsEndpoint = "api/v1/foods/";
const getFoodsDataEndpoint = "api/v1/foods/data/";
const getFoodsTypesEndpoint = "api/v1/foods/food-types";
const setFoodEndpoint = "api/v1/foods/set-food";
const createMneuEndpoint = "api/v1/menus/create-menu";
const getMenusEndpoint = "api/v1/menus/getAll/";
const getMenuPriceEndpoint = "api/v1/menus/get-menu-price";
const postEmailEndpoint = "api/v1/menus/email";
const getEmailShareEndpoint = "api/v1/menus/share/";
const deleteMenuEndpoint = "api/v1/menus/delete/";
const setFoodTypeEndpoint = "api/v1/foods/set-food-types";
const updateMenuEndpoint = "api/v1/menus/update-menu/";

export default {
  setAxios(){
    menu = Axios.create({
      baseURL:constants.APIURL,
      withCredentials: false, // This is the default
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    });
  },
  getFoods(nutritionist_id) {
    return menu.get(getFoodsEndpoint+nutritionist_id);
  },
  getFoodsData(nutritionist_id){
    return menu.get(getFoodsDataEndpoint+nutritionist_id);
  },
  setFood(body){
    return menu.post(setFoodEndpoint,body);
  },
  getFoodsTypes(){
    return menu.get(getFoodsTypesEndpoint);
  },
  createMenu(body) {
    return menu.post(createMneuEndpoint,body);
  },
  getMenus(nutritionist_id) {
    return menu.get(getMenusEndpoint + nutritionist_id);
  },
  getMenusPrice() {
    return menu.get(getMenuPriceEndpoint);
  },
  email(body){
    return menu.post(postEmailEndpoint,body);
  },
  getSharedMenu(uid){
    return menu.get(getEmailShareEndpoint+uid);
  },
  deleteMenu(id){
    return menu.delete( deleteMenuEndpoint+id);
  },
  setFoodType(body){
    return menu.post(setFoodTypeEndpoint,body);
  },
  updateMenu(id,body) {
    return menu.post(updateMenuEndpoint+id,body);
  }
  
}
